var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Toast } from '../../components/Toast';
export class Dashboard extends Component {
    constructor() {
        super('Dashboard', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#switch-user-pause-status').on('change', (event) => __awaiter(this, void 0, void 0, function* () {
                const target = event.target;
                const content = yield $.httpRequest({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    body: {
                        action: 'hw_switch_user_pause_status',
                        status: target.checked ? 1 : 0,
                    },
                    dataType: 'json'
                });
                Toast.show(content.data.message);
            }));
            this.success();
        });
    }
}
